import React from 'react'
import CreateIndividualClass from '../../components/admin/CreateIndividual/CreateIndividualClass'

function IndividualClassPage() {
  return <CreateIndividualClass />
}

export default IndividualClassPage
